import { render, staticRenderFns } from "./SettingsOrders.vue?vue&type=template&id=035f4d1a&"
import script from "./SettingsOrders.vue?vue&type=script&lang=js&"
export * from "./SettingsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports